export default "__VITE_ASSET__oEGLOjlq__"